<!--
 * @LastEditors: chuhongguang
 * @desc: 表格数据的详情
 * @场景1: 数据库-我的数据-表格数据 详情
 * @场景2: 重构因子抽屉 - 制表记录 - 计算完成（或 检测按钮） - 数据详情
-->
<template>
  <div>
    <div class="space_between" style="align-items: center;margin: 10px 0;">
      <span>&nbsp;</span>
      <!-- <div v-if="this.dtesLen !== 0">
        标的
        <el-autocomplete
          style="width: 200px;margin-right: 20px;"
          v-model="tickerInput"
          clearable
          :fetch-suggestions="querySearchTicker"
          placeholder="请输入内容"
          @select="tickerSelect('ticker')"
          @clear="tickerClear('ticker')"
        >
          <template slot-scope="{ item }">
            <div class="name">{{item.value}}</div>
          </template>
          <el-button slot="append" icon="el-icon-search" @click="tickerSelect('ticker')"></el-button>
        </el-autocomplete>
        日期
        <el-autocomplete
          style="width: 200px;"
          v-model="dateInput"
          clearable
          :fetch-suggestions="querySearchDate"
          placeholder="请输入内容"
          @select="tickerSelect('date')"
          @clear="tickerClear('date')"
        >
          <template slot-scope="{ item }">
            <div class="name">{{item.value}}</div>
          </template>
          <el-button slot="append" icon="el-icon-search" @click="tickerSelect('date')"></el-button>
        </el-autocomplete>
      </div> -->
      <div class="font_s_14 align_right">
        <span class="copyClass" ref="copyRef" @click="copySearch($event)">&nbsp;&nbsp;</span>
        <i @click="handleCopy($event)" class="el-icon-document-copy cursor">拷贝数据</i>
      </div>
    </div>
    <div id="grid1" v-loading="loading">
      <vxe-grid
        border
        show-overflow
        show-header-overflow="title"
        ref="xGrid"
        height="400"
        row-id="date"
        @scroll="handleScroll"
        :checkbox-config="{checkField: 'checked', labelField: 'date'}">
      </vxe-grid>
    </div>
  </div>
</template>
<script>
import { getRequest } from '@/api/dailyBackTest.js'
import clip from '@/utils/clipboard'
export default {
  props: ['matrixData'],
  data () {
    return {
      loading: false,
      list: [], // 上万条总数据
      clist: [], // 页面展示数据
      viewH: 337, // 外部box高度
      itemH: 48, // 单项高度
      offsetY: 0, // 动态偏移量
      // scrollH: '', // 整个滚动列表高度
      viewW: '', // 外部box宽度
      itemW: 140, // 单项宽度
      offsetX: 0, // 动态偏移量
      // scrollw: '', // 整个滚动列表高度
      showNum: '', // 可视化高度一次能装几个列表
      obtainTop: '', // 获取的数据位置
      obtainLeft: '',
      tableList: [],
      dateList: [],
      tickerList: [],
      nameList: [],
      dtesLen: undefined,
      tkrsLen: 0,
      tickerInput: '',
      dateInput: '',
      allColumn: [],
      allData: [],
      w: 120,
      h: 60,
      heightLenght: 8,
      widthLenght: '',
      startIndexH: '',
      startIndexW: '',
      x: 0,
      y: 0,
      dimension: ''
    }
  },
  created () {
    // 动态定义，阻断 vue 对大数据双向绑定，提升加载速度
    this.allData = []
    this.allColumn = []
    // this.getTickerData()
  },
  mounted () {
    this.lastTime = new Date().getTime()
    this.widthLenght = this.width
    this.viewW = this.view
    if (this.date) {
      this.dateInput = this.date
    }
    if (this.matrixData._id) {
      this.dateList = this.matrixData.row
      this.nameList = this.matrixData.column
      this.getTableData(this.x, this.y, 'init')
    }
  },
  watch: {
    matrixData (newVal, oldVal) {
      this.loading = true
      this.allData = []
      this.allColumn = []
      if (newVal.id && newVal.id !== oldVal.id) {
        this.matrixData = newVal
        this.dateList = this.matrixData.row
        this.nameList = this.matrixData.column
        this.x = 0
        this.y = 0
        this.getTableData(this.x, this.y, 'init')
      } else if (!newVal.id) {
        this.loading = false
        this.$refs.xGrid.loadColumn(this.allColumn)
        this.$refs.xGrid.loadData(this.allData)
      }
      // console.log(this.viewW)
    }
  },
  methods: {
    copySearch (event) {
      clip(this.copyText, event)
    },
    handleCopy (event) {
      var _this = this
      let dateList = this.dateList
      let nameList = this.nameList
      let params = {
        x: 0,
        y: 0,
        w: this.dateList.length,
        h: this.nameList.length,
        id: this.matrixData._id
      }
      getRequest('/dataSupport/getMatrixByCoordinate', params).then(function (x) {
        if (!x.data.message) {
          let tableList = x.data.data
          let text = '日期\t'
          for (let i = 0; i < nameList.length; i++) {
            text = text + nameList[i] + '\t'
          }
          // console.log(dateList, nameList, tableList)
          for (let i = 0; i < dateList.length; i++) {
            text = text + '\n' + dateList[i] + '\t'
            for (let j = 0; j < nameList.length; j++) {
              // console.log(tableList[i])
              if (tableList[i][j] !== null && tableList[i][j] !== undefined) {
                text = text + tableList[i][j] + '\t'
              } else {
                text = text + '\t'
              }
            }
          }
          _this.copyText = text
          _this.$refs.copyRef.click()
        }
      })
    },
    tickerClear (key) {
      let tickerLenght
      let dateLenght
      if (key === 'ticker') {
        tickerLenght = 0
      }
      if (key === 'date') {
        dateLenght = 0
      }
      if (dateLenght !== undefined || tickerLenght !== undefined) {
        this.select(dateLenght, tickerLenght)
      }
    },
    tickerSelect (key) {
      // console.log(key, this.tickerInput, this.dateInput)
      let tickerLenght
      let dateLenght
      var resultTicker = this.tickerInput ? this.nameList.filter(this.createFilter(this.tickerInput)) : this.nameList
      var resultData = this.dateInput ? this.dateList.filter(this.createFilter(this.dateInput)) : this.dateList
      if (key === 'ticker') {
        if (resultTicker.length > 0) {
          let index = this.nameList.indexOf(resultTicker[0])
          if (index > -1) {
            tickerLenght = index
          }
        } else {
          this.$message.error('没有该条数据！')
        }
        if (this.dateInput) {
          if (this.dateList.indexOf(resultData[0]) > -1) {
            dateLenght = this.dateList.indexOf(resultData[0])
          }
        }
      }
      if (key === 'date') {
        if (resultData.length > 0) {
          if (this.dateList.indexOf(resultData[0]) > -1) {
            dateLenght = this.dateList.indexOf(resultData[0])
          }
        } else {
          this.$message.error('没有该条数据！')
        }
        if (this.tickerInput) {
          let index = this.nameList.indexOf(resultTicker[0])
          if (index > -1) {
            tickerLenght = index
          }
        }
      }
      if (dateLenght !== undefined || tickerLenght !== undefined) {
        this.select(dateLenght, tickerLenght)
      }
    },
    select (dateLenght, tickerLenght) {
      if (dateLenght !== undefined) {
        this.startIndexH = dateLenght
      }
      if (tickerLenght !== undefined) {
        this.startIndexW = tickerLenght
      }
      let endIndexH = this.startIndexH + Math.ceil(337 / 48) // 高度结束位置
      let endIndexW = this.startIndexW + Math.ceil(this.viewW / 140) // 宽度结束位置
      let endY = this.x + this.w
      let endX = this.y + this.h
      let y
      let x
      if ((this.startIndexH - this.x) / this.w < 0.2 || (this.startIndexW - this.y) / this.h < 0.2 || (endY - endIndexH) / this.w < 0.2 || (endX - endIndexW) / this.h < 0.2) {
        if ((this.startIndexH - this.x) / this.w < 0.2) {
          if ((this.startIndexH - Math.floor((this.w - this.heightLenght) / 2)) > 0) {
            x = this.startIndexH - Math.floor((this.w - this.heightLenght) / 2)
          } else {
            x = 0
          }
        } else if ((endY - endIndexH) / this.w < 0.2) {
          if ((this.startIndexH - Math.floor((this.w - this.heightLenght) / 2)) > 0) {
            x = this.startIndexH - Math.floor((this.w - this.heightLenght) / 2)
          }
        }
        if ((this.startIndexW - this.y) / this.h < 0.2) {
          if ((this.startIndexW - Math.floor((this.h - this.widthLenght) / 2)) > 0) {
            y = this.startIndexW - Math.floor((this.h - this.widthLenght) / 2)
          } else {
            y = 0
          }
        } else if ((endX - endIndexW) / this.h < 0.2) {
          if ((this.startIndexW - Math.floor((this.h - this.widthLenght) / 2)) > 0) {
            y = this.startIndexW - Math.floor((this.h - this.widthLenght) / 2)
          }
        }
      }
      if ((y !== undefined && this.y !== y) || (x !== undefined && this.x !== x)) {
        if (x !== undefined) {
          this.x = x
        }
        if (y !== undefined) {
          this.y = y
        }
        // console.log('xy------->', this.x, this.y)
        this.getTableData(this.x, this.y)
      }
      // console.log(this.startIndexW * 140, this.startIndexH * 48)
      this.$refs.xGrid.scrollTo(this.startIndexW * 140, this.startIndexH * 48)
    },
    querySearchTicker (queryString, cb) {
      var results = []
      var restaurants = this.nameList
      var result = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // console.log(result)
      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          results.push({value: result[i]})
        }
      }
      cb(results)
    },
    querySearchDate (queryString, cb) {
      var results = []
      var restaurants = this.dateList
      var result = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          results.push({value: result[i].toString()})
        }
      }
      cb(results)
      return results
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.toString().toLowerCase().indexOf(queryString.toString().toLowerCase()) > -1)
      }
    },
    getTableData (i, j, key) {
      var _this = this
      var params = {
        x: i,
        y: j,
        w: this.w,
        h: this.h,
        id: this.matrixData._id
      }
      getRequest('/dataSupport/getMatrixByCoordinate', params).then(function (x) {
        if (!x.data.message) {
          _this.tableList = x.data.data
          if (key === 'init') {
            _this.init()
          } else {
            _this.addAllData(key)
          }
        }
      })
    },
    debounce () {
      // 每次按下键盘的时候都会触发这个函数，
      // 先清除定时器然后再设置定时器，他就会从新开始计时
      var _this = this
      this.tishi = ''
      this.is_asset = null
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        _this.getTableData(this.x, this.y)
      }, 500)
    },
    handleScroll (e) {
      // this.scrollH = e.scrollTop
      // this.scrollW = e.scrollLeft
      if (new Date().getTime() - this.lastTime > 10) {
        // console.log(e)
        let scrollTop = e.scrollTop // 滚去的高度
        let scrollLeft = e.scrollLeft // 滚去的宽度
        this.startIndexH = Math.ceil(scrollTop / 48) // 高度开始位置
        this.startIndexW = Math.ceil(scrollLeft / 140) // 宽度开始位置
        let endIndexH = Math.ceil((scrollTop + 337) / 48) // 高度结束位置
        let endIndexW = Math.ceil((scrollLeft + this.viewW) / 140) // 宽度结束位置
        let endY = this.x + this.w
        let endX = this.y + this.h
        let y
        let x
        if ((this.startIndexH - this.x) / this.w < 0.2 || (this.startIndexW - this.y) / this.h < 0.2 || (endY - endIndexH) / this.w < 0.2 || (endX - endIndexW) / this.h < 0.2) {
          if ((this.startIndexH - this.x) / this.w < 0.2) {
            if ((this.startIndexH - Math.floor((this.w - this.heightLenght) / 2)) > 0) {
              x = this.startIndexH - Math.floor((this.w - this.heightLenght) / 2)
            } else {
              x = 0
            }
          } else if ((endY - endIndexH) / this.w < 0.2) {
            if ((this.startIndexH - Math.floor((this.w - this.heightLenght) / 2)) > 0) {
              x = this.startIndexH - Math.floor((this.w - this.heightLenght) / 2)
            }
          }
          if ((this.startIndexW - this.y) / this.h < 0.2) {
            if ((this.startIndexW - Math.floor((this.h - this.widthLenght) / 2)) > 0) {
              y = this.startIndexW - Math.floor((this.h - this.widthLenght) / 2)
            } else {
              y = 0
            }
          } else if ((endX - endIndexW) / this.h < 0.2) {
            if ((this.startIndexW - Math.floor((this.h - this.widthLenght) / 2)) > 0) {
              y = this.startIndexW - Math.floor((this.h - this.widthLenght) / 2)
            }
          }
        }
        if ((y !== undefined && this.y !== y) || (x !== undefined && this.x !== x)) {
          if (x !== undefined) {
            this.x = x
          }
          if (y !== undefined) {
            this.y = y
          }
          // console.log('xy-------------------->', this.x, this.y)
          this.debounce(this.x, this.y)
        }
        this.lastTime = new Date().getTime()
      }
    },
    addAllData (key) {
      if (this.allData.length < 1) {
        return
      }
      Promise.all([
        this.findDataList(150).then(data => {
          // console.log(data)
          this.allData = data
          this.$refs.xGrid.loadData(this.allData)
          // console.log(this.allData)
        })
      ]).then(() => {
      })
    },
    init () {
      Promise.all([
        this.findColumnList(100).then(data => {
          // console.log(data)
          this.allColumn = data
          this.$refs.xGrid.loadColumn(this.allColumn)
        }),
        this.findDataList(150).then(data => {
          // console.log(data)
          this.allData = data
          this.$refs.xGrid.loadData(this.allData)
          // console.log(this.allData)
        })
      ]).then(() => {
        this.loading = false
        this.viewW = document.getElementById('grid1').scrollWidth - 15
        this.widthLenght = Math.ceil(this.viewW / 140) - 1
        if (this.dateInput) {
          setTimeout(() => {
            this.tickerSelect('date')
          }, 200)
        }
        // console.log(this.viewW)
      })
    },
    findColumnList (size) {
      return new Promise(resolve => {
        setTimeout(() => {
          var columns = []
          var colIndex = 0
          for (var index = 0; index < this.nameList.length + 1; index++) {
            let key = colIndex++
            let config = {
              field: key ? index : 'date',
              title: key ? this.nameList[index - 1] : '',
              width: 140
            }
            // let config = {
            //   field: key ? index : 'date',
            //   title: key ? index : '',
            //   width: 140
            // }
            // if (!key) {
            //   config.type = 'checkbox'
            // }
            if (key < 1) {
              // config.type = 'checkbox'
              config.fixed = 'left'
            }
            columns.push(config)
          }
          resolve(columns)
        }, 0)
      })
    },
    findDataList (size) {
      return new Promise(resolve => {
        setTimeout(() => {
          var list = []
          let rowIndex = 0
          for (var index = 0; index < this.dateList.length; index++) {
            let item = { date: this.dateList[index] }
            // let item = { date: index }
            // 由于生成数据比较耗时，所以固定生成1000字段
            if (index < (this.w + this.x) && index > this.x - 1) {
              let hLenght = this.h
              if (hLenght > this.nameList.length) {
                hLenght = this.nameList.length
              }
              // console.log(hLenght)
              let key = rowIndex++
              Array.from(new Array(hLenght)).forEach((num, cIndex) => {
                // item[cIndex] = '( ' + cIndex + ' , ' + index + ' )'
                let number = cIndex + this.y
                let clist = number + 1
                // console.log(number)
                // console.log(clist)
                // console.log(this.tableList[key], key, cIndex)
                if (this.tableList[key][cIndex] === null) {
                  item[clist] = '-'
                } else {
                  item[clist] = this.tableList[key][cIndex]
                }
              })
            }
            list.push(item)
            // console.log(item)
          }
          resolve(list)
        }, 250)
      })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/allPage/vxeTablefunc.vue